import React from "react";
import { StyledTabs } from "./Tabs.styles";

import { Tab } from "@ubnt/ui-components/Tabs";
import clsx from "clsx";

export const Tabs = ({
  tabs,
  selected,
  onSelect,
  className,
  tabsClassName,
}: {
  tabs: Array<Tab>;
  selected: Tab["id"];
  onSelect: (id: Tab["id"]) => void;
  className?: string;
  tabsClassName?: string;
}) => {
  return (
    <StyledTabs
      className={className}
      selectedTab={selected}
      tabs={tabs}
      variant="capsule"
      tabsClassName={clsx("tabs", tabsClassName)}
      tabClassName="tab"
      selectedTabClassName="selected-tab"
      onSelectTab={({ id }) => onSelect(id)}
    />
  );
};
